import RequiredMark from "@atoms/RequiredMark/RequiredMark";

import * as S from "./TableCreatorGroupTableTitle.style";

interface Props {
  title: string;
  titleColor?: string;
  isRequired: boolean;
  onClickHandler?: () => void;
}

const TableCreatorGroupTableTitle = ({
  title,
  titleColor,
  isRequired,
  onClickHandler,
}: Props) => {
  return (
    <S.GroupTableTitle onClick={onClickHandler}>
      {isRequired && <RequiredMark text="*" />}
      <S.Title $titleColor={titleColor}>{title}</S.Title>
    </S.GroupTableTitle>
  );
};

export default TableCreatorGroupTableTitle;
